// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1EcqX","title":"styles_title__2lkLi"};